import type { ObjectId } from '@freightview/object-id'

import { vObject, type vOutput, vString } from '../validation/index.js'
import type { HazardClass, HazardSubClass } from './common.js'

export const cfrHazmatSearchSchema = vObject({ properShippingName: vString() })
export const cfrHazmatIdNumberSearchSchema = vObject({
  identificationNumber: vString(),
})

export type CfrHazmatSearchQuery = vOutput<typeof cfrHazmatSearchSchema>
export type CfrHazmatIdNumberSearchQuery = vOutput<
  typeof cfrHazmatIdNumberSearchSchema
>

export interface CfrHazardousMaterial {
  _id: ObjectId
  symbols: CfrSymbol[]
  properShippingName: string
  qualifier?: string
  primaryClass?: HazardClass
  identificationNumber: string
  packingGroups: CfrPackingGroup[]
  secondaryClass?: HazardSubClass
  tertiaryClass?: HazardSubClass
}

export const cfrPackingGroups = ['I', 'II', 'III'] as const
export type CfrPackingGroup = (typeof cfrPackingGroups)[number]

export const cfrSymbols = ['+', 'A', 'D', 'G', 'I', 'W'] as const
export type CfrSymbol = (typeof cfrSymbols)[number]
